"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAppBarDefaultProps = exports.createAppBarTheme = void 0;
exports.createAppBarTheme = function (_a) {
    var palette = _a.palette;
    return ({
        colorDefault: {
            backgroundColor: palette.common.white,
        },
    });
};
exports.createAppBarDefaultProps = function () { return ({}); };
